<header class="col-12 header-page">
    <h1 class="header__page__content__title">
        Dados do Plano Previdência
    </h1>
</header>
<ng-template #showLoading>
    <spinner [show]="true"></spinner>
</ng-template>
<main class="main__content col-xl-12" *ngIf="!loading && contribuicaoReserva; else showLoading">
    <!-- <form class="col-xl-12 col-lg-12 col-md-12 col-sm-12 main__page__content__form" [formGroup]="formGroup"
        *ngIf="contribuicaoReserva && contribuicaoReserva.total != 0">
        <section class="col-12 content-form">
            <div class="col-xl-4 px-0 content-form-ng-select">
                <label class="content__form__title__label" for="anoSelecionado">Seleciona o ano</label>
                <ng-select [items]="contribuicaoReserva.year" bindLabel="year" bindValue="year" placeholder="Selecione"
                    appendTo="body" formControlName="anoSelecionado" (close)="changeYear()">
                </ng-select>
                <small></small>
            </div>
        </section>
    </form> -->
    <section>
        <section class="row" *ngIf="contribuicaoReserva && contribuicaoReserva.total != 0">
            <section class="col-xl-6 col-md-12 col-sm-12 p-2 mt-2">
                <!-- <h3>Composição da Reserva - ({{ formGroup.get('anoSelecionado')?.value }})</h3> -->
                <h3 *ngIf="usuarioAtual?.socialSecurityProfile?.id != 4">Composição da Reserva Total</h3>
                <h3 *ngIf="usuarioAtual?.socialSecurityProfile?.id == 4">Composição de Reserva Total, Saldo Total,
                    Contribuição e Meu plano</h3>
                <!-- <pie-chart [valorTotal]="dataSelecionada?.total" [valorPatrocinadora]="dataSelecionada?.sponsor"
                    [valorRentabilidade]="dataSelecionada?.profit" [valorParticipante]="dataSelecionada?.person"
                    [valorPortabilidade]="dataSelecionada?.portabilidade" [idChart]="'patrocinadoraChart'"
                    [titleChart]="'Patrocinadora'" *ngIf="contribuicaoReserva">
                </pie-chart> -->
                <pie-chart [valorTotal]="contribuicaoReserva?.total" [valorPatrocinadora]="contribuicaoReserva?.sponsor"
                    [valorRentabilidade]="contribuicaoReserva?.profit" [valorParticipante]="contribuicaoReserva?.person"
                    [valorPortabilidade]="contribuicaoReserva?.portabilidade" [idChart]="'patrocinadoraChart'"
                    [titleChart]="'Patrocinadora'" *ngIf="contribuicaoReserva">
                </pie-chart>
            </section>
            <section class="col-xl-6 p-2">
                <div class="main__content__dados__reserva" *ngIf="contribuicaoReserva">
                    <div class="col-6 main__content__card mt-2">
                        <span class="content__card__title">
                            Saldo Total
                        </span>
                        <p class="content__card__content">
                            <img class="card__content__icon" src="../../../../../../assets/img/svg/Botao total.svg" />
                            <span>
                                {{contribuicaoReserva?.total | currency:'BRL' }}
                                <fa-icon class="fa-icon-dashboard" [icon]="faArrowUp"></fa-icon>
                            </span>
                        </p>
                    </div>
                    <!-- <div class="col-6 main__content__card mt-2">
                        <span class="content__card__title">
                            Saldo em {{ formGroup.get('anoSelecionado')?.value }}
                        </span>
                        <p class="content__card__content">
                            <img class="card__content__icon" src="../../../../../../assets/img/svg/Botão ano.svg" />
                            <span>
                                {{ dataSelecionada?.total | currency:'BRL' }}
                                <fa-icon class="fa-icon-dashboard" [icon]="faArrowUp"></fa-icon>
                            </span>
                        </p>
                    </div> -->
                </div>
                <table class="col-12">
                    <thead>
                        <tr>
                            <th>Contribuições</th>
                            <th>Valor Total</th>
                            <th>%</th>
                            <!-- <th>Valor {{ formGroup.get('anoSelecionado')?.value }}</th>
                            <th>%</th> -->
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>Participante</td>
                            <td>{{ contribuicaoReserva?.person | currency:'BRL' }}</td>
                            <td>{{ contribuicaoReserva?.personPercent | percentage }}</td>
                            <!-- <td>{{ dataSelecionada?.person | currency:'BRL' }}</td>
                            <td>{{ dataSelecionada?.personPercent | percentage }}</td> -->
                        </tr>
                        <tr>
                            <td>Patrocinadora</td>
                            <td>{{ contribuicaoReserva?.sponsor | currency:'BRL' }}</td>
                            <td>{{ contribuicaoReserva?.sponsorPercent | percentage }}</td>
                            <!-- <td>{{ dataSelecionada?.sponsor | currency:'BRL' }}</td>
                            <td>{{ dataSelecionada?.sponsorPercent | percentage }}</td> -->
                        </tr>
                        <tr>
                            <td>Rentabilidade</td>
                            <td>{{ contribuicaoReserva?.profit | currency:'BRL' }}</td>
                            <td>{{ contribuicaoReserva?.profitPercent | percentage }}</td>
                            <!-- <td>{{ dataSelecionada?.profit | currency:'BRL' }}</td>
                            <td>{{ dataSelecionada?.profitPercent | percentage }}</td> -->
                        </tr>
                        <tr *ngIf="contribuicaoReserva.portabilidade">
                            <td>Portabilidade</td>
                            <td>{{ contribuicaoReserva?.portabilidade | currency:'BRL' }}</td>
                            <td>{{ contribuicaoReserva?.portabilidadePercent | percentage }}</td>
                            <!-- <td>{{ dataSelecionada?.portabilidade | currency:'BRL' }}</td>
                            <td>{{ dataSelecionada?.portabilidadePercent | percentage }}</td> -->
                        </tr>
                    </tbody>
                </table>
            </section>
        </section>
        <section class="mt-2 row">
            <section class="col-xl-5 col-lg-12 col-md-12 col-sm-12 p-2 mt-2">
                <h3>Contribuição</h3>
                <section class="content-contribuicao mt-2" *ngIf="personData && personData.contribution.length > 0">
                    <div class="p-0 content-form-ng-select">
                        <label class="content__form__title__label">Tipo</label>
                        <ng-select [items]="personData.contribution" bindLabel="contributionTypeName" bindValue=""
                            placeholder="Selecione" appendTo="body" [searchable]="false"
                            [(ngModel)]="contribuicaoSelecionada">
                        </ng-select>
                        <small></small>
                    </div>
                    <section class="content-contribuicao-dados">
                        <div *ngIf="usuarioAtual?.socialSecurityProfile?.id != 4">
                            <span class="dados__participante__label">Opção</span>
                            <p class="dados__participante__data">{{contribuicaoSelecionada?.optionPercentage |
                                percentage}}</p>
                        </div>
                        <div>
                            <span class="dados__participante__label">Periodicidade</span>
                            <p class="dados__participante__data">{{contribuicaoSelecionada?.frequency}}</p>
                        </div>
                        <div>
                            <span class="dados__participante__label">Membro Responsável</span>
                            <p class="dados__participante__data">{{contribuicaoSelecionada?.responsibleMember}}</p>
                        </div>
                        <div>
                            <span class="dados__participante__label">Última Contribuição</span>
                            <p class="dados__participante__data">
                                R$ {{(contribuicaoSelecionada?.lastContribution | number: "1.2-2") || ' -'}}</p>
                        </div>
                    </section>
                </section>
            </section>
            <section class="col-xl-7 p-2 mt-2" *ngIf="planoSelecionado">
                <h3>Meu Plano</h3>
                <section class="main__content__dados__participante mt-2">
                    <div>
                        <span class="dados__participante__label">Meu plano</span>
                        <p class="dados__participante__data">{{planoSelecionado.planName}}</p>
                    </div>
                    <div>
                        <span class="dados__participante__label">CNPB</span>
                        <p class="dados__participante__data" mask="0000.0000-00">
                            {{usuarioAtual?.socialSecurityProfile?.cnpb |
                            mask: "0000.0000-00"}}</p>
                    </div>
                    <div>
                        <span class="dados__participante__label">Tipo de Participante</span>
                        <p class="dados__participante__data">{{planoSelecionado.planUserTypeName}}</p>
                    </div>
                    <div>
                        <span class="dados__participante__label">Data início</span>
                        <p class="dados__participante__data">{{planoSelecionado.start | date:'dd/MM/yyyy'}}</p>
                    </div>
                    <div>
                        <span class="dados__participante__label">Data fim</span>
                        <p class="dados__participante__data">{{ (planoSelecionado.end | date:'dd/MM/yyyy') || ' - ' }}
                        </p>
                    </div>
                    <div>
                        <span class="dados__participante__label">Situação do plano</span>
                        <p class="dados__participante__data">{{planoSelecionado.statusName}}</p>
                    </div>
                    <div>
                        <span class="dados__participante__label">Tipo de Tributação</span>
                        <p class="dados__participante__data">{{planoSelecionado.tributeTypeName}}</p>
                    </div>
                </section>
            </section>
        </section>
        <section class="row">
            <section class="col-xl-7 p-2 mt-2"
                *ngIf="planoSelecionado && planoSelecionado.planUserTypeId == beneficiaryType.ASSISTIDO">
                <h3>Concessão de Benefícios</h3>
                <section class="content-concessao-beneficio">
                    <section class="main__content__dados__participante">
                        <div>
                            <span class="dados__participante__label">Plano</span>
                            <p class="dados__participante__data">{{benefitGranted?.planName || ' - '}}</p>
                        </div>
                        <div>
                            <span class="dados__participante__label">Data início do Pagamento</span>
                            <p class="dados__participante__data">{{(benefitGranted?.startPayment | date:'dd/MM/yyyy') ||
                                ' - ' }}</p>
                        </div>
                        <div>
                            <span class="dados__participante__label">Benefício</span>
                            <p class="dados__participante__data">{{benefitGranted?.benefitName || ' - '}}</p>
                        </div>
                        <div>
                            <span class="dados__participante__label">Data de Início do Benefício</span>
                            <p class="dados__participante__data">{{(benefitGranted?.start | date:'dd/MM/yyyy') ||
                                ' - '}}</p>
                        </div>
                        <div>
                            <span class="dados__participante__label">Motivo do Benefício</span>
                            <p class="dados__participante__data">{{benefitGranted?.benefitReasonDesc || ' - '}}</p>
                        </div>
                        <div>
                            <span class="dados__participante__label">Nº Processo INSS</span>
                            <p class="dados__participante__data">{{benefitGranted?.protocolINSS || ' - '}}</p>
                        </div>
                        <div>
                            <span class="dados__participante__label">Forma de Pagamento</span>
                            <p class="dados__participante__data">{{benefitGranted?.paymentMethodName || ' - '}}</p>
                        </div>
                        <div>
                            <span class="dados__participante__label">Descrição</span>
                            <p class="dados__participante__data">{{benefitGranted?.description || ' - '}}</p>
                        </div>
                    </section>
                    <ng-template #emptyShortages>
                        Não possui
                    </ng-template>
                    <div *ngIf="benefitGranted?.shortages && benefitGranted.shortages.length > 0; else emptyShortages">
                        <section class="content__header__table">
                            <div class="col-xl-3">Carência</div>
                            <div class="col-xl-3">Inicio de vigência</div>
                            <div class="col-xl-2">Fim da vigência</div>
                            <div class="col-xl-2">Quantidade de meses</div>
                        </section>
                        <section class="content__main__table">
                            <div class="table__card"
                                *ngFor="let shortage of benefitGranted.shortages; let firstItem = first">
                                <div class="col-xl-3">
                                    <!-- <span class="table__legenda__mobile">Data do Crédito: </span> -->
                                    <span>{{ shortage.name }}</span>
                                </div>
                                <div class="col-xl-3">
                                    <!-- <span class="table__legenda__mobile">Data do Crédito: </span> -->
                                    <span>{{ shortage.start | date:'dd/MM/yyyy' }}</span>
                                </div>
                                <div class="col-xl-2">
                                    <!-- <span class="table__legenda__mobile">Data do Crédito: </span> -->
                                    <span>{{ shortage.ends | date:'dd/MM/yyyy' }}</span>
                                </div>
                                <div class="col-xl-2">
                                    <!-- <span class="table__legenda__mobile">Saldo Devedor: </span> -->
                                    <span>{{ shortage.months }}</span>
                                </div>
                            </div>
                        </section>
                    </div>
                </section>
            </section>
        </section>
        <section class="row" *ngIf="usuarioAtual?.socialSecurityProfile?.id != 4">
            <section class="col-xl-6 p-2 mt-2">
                <h3>Designação da Reserva de Poupança</h3>
                <ng-template #naoPossuiDesignacaoPoupanca>
                    <p class="col-12 ng-template-text">
                        Você não possui Designação de Poupança!
                    </p>
                </ng-template>
                <div
                    *ngIf="listDesignacaoPoupanca && listDesignacaoPoupanca.length > 0 else naoPossuiDesignacaoPoupanca">
                    <section class="content__header__table">
                        <div class="col-xl-4">CPF</div>
                        <div class="col-xl-4">Nome</div>
                        <div class="col-xl-4">Parentesco</div>
                        <!-- <div class="col-xl-2">Percentual</div> -->
                    </section>
                    <section class="content__main__table">
                        <div class="table__card" *ngFor="let item of listDesignacaoPoupanca; let firstItem = first">
                            <ng-template #naoPossuiValor>
                                <span> - </span>
                            </ng-template>
                            <div class="col-xl-4">
                                <span *ngIf="item.cpf else naoPossuiValor">{{ item.cpf | cpfCnpj }}</span>
                            </div>
                            <div class="col-xl-4">
                                <span *ngIf="item.name else naoPossuiValor">{{ item.name | fatherLastName }}</span>
                            </div>
                            <div class="col-xl-4">
                                <span *ngIf="item.familyType else naoPossuiValor">{{ item.familyType }}</span>
                            </div>
                            <!-- <div class="col-xl-2">
                                <span>{{ item.percentagem | percentage }}</span>
                            </div> -->
                        </div>
                    </section>
                </div>
            </section>
            <section class="col-xl-6 p-2 mt-2">
                <h3>Dependente Previdenciário</h3>
                <ng-template #naoPossuiDependentePrevidencia>
                    <p class="col-12 ng-template-text">
                        Você não possui dependentes de Previdência!
                    </p>
                </ng-template>
                <div
                    *ngIf="listDependentePrevidenciario && listDependentePrevidenciario.length > 0 else naoPossuiDependentePrevidencia">
                    <section class="content__header__table">
                        <div class="col-xl-4">CPF</div>
                        <div class="col-xl-4">Nome</div>
                        <div class="col-xl-4">Parentesco</div>
                    </section>
                    <section class="content__main__table">
                        <div class="table__card"
                            *ngFor="let item of listDependentePrevidenciario; let firstItem = first">
                            <ng-template #naoPossuiValor>
                                <span> - </span>
                            </ng-template>
                            <div class="col-xl-4">
                                <span *ngIf="item.cpf else naoPossuiValor">{{ item.cpf | cpfCnpj }}</span>
                            </div>
                            <div class="col-xl-4">
                                <span *ngIf="item.name else naoPossuiValor">{{ item.name | fatherLastName }}</span>
                            </div>
                            <div class="col-xl-4">
                                <span *ngIf="item.familyType else naoPossuiValor">{{ item.familyType }}</span>
                            </div>
                        </div>
                    </section>
                </div>
            </section>
        </section>
    </section>
</main>